import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { listCampuses } from "../service/campusService";
import type { Campus } from "../types";

interface CampusesState {
  campuses: Campus[];
  loading: boolean;
}

const initialState: CampusesState = {
  campuses: [],
  loading: false,
};

export const loadCampuses = createAsyncThunk(
  "campuses/load",
  async (organizationId: number) => {
    return await listCampuses(organizationId);
  }
);

const campusesSlice = createSlice({
  name: "campuses",
  initialState,
  reducers: {
    clearCampuses(state) {
      state.campuses = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadCampuses.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadCampuses.fulfilled, (state, action) => {
        state.loading = false;
        state.campuses = action.payload;
      })
      .addCase(loadCampuses.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { clearCampuses } = campusesSlice.actions;
export default campusesSlice.reducer;